<template>
    <div>
        <loader v-if="!isDataAvailable" style="min-height: 100px;" />
        <form class="form-horizontal">
            <div class="form-group">
                <label class="col-sm-2 control-label text-label">Type</label>
                <div class="col-sm-4 text-label">{{ workflowDescription }}</div>
            </div>
            <div class="form-group">
                <label class="col-sm-2 control-label text-label">Complete Date</label>
                <div class="col-sm-4 text-label">{{ completeDateComputed }}</div>
            </div>
        </form>
    </div>
</template>

<style>
</style>

<script>
import loggingService from '@/services/util/loggingService'
import componentService from '@/services/util/componentService'
import loader from '@/components/Loader.vue'

export default {
    components: {
        loader
    },
    name: 'workflowInstance',
    data: function () {
        return {
            isDebug: false
        }
    },
    props: {
        workflowInstanceDto: {
            type: Object
        }
    },
    computed: {
        componentName: function () {
            return componentService.getComponentNameDebug(this)
        },
        isDataAvailable: function () {
            return this.workflowInstanceDto != null
        },
        workflowDescription: function () {
            if (!this.isDataAvailable) {
                return 'N/A'
            }

            return this.workflowInstanceDto.workflowDescription
        },
        completeDateComputed: function (completeDate) {
            if (!this.isDataAvailable) {
                return 'N/A'
            }

            if (this.workflowInstanceDto.completeDate == null) {
                return 'N/A'
            }

            return this.workflowInstanceDto.completeDateFormatted
        }
    },
    created () {
        loggingService.log(this.isDebug, this.componentName, 'created')
    },
    mounted () {
        loggingService.log(this.isDebug, this.componentName, 'mounted')
    },
    destroyed () {
        loggingService.log(this.isDebug, this.componentName, 'destroyed')
    }
}

</script>



// WEBPACK FOOTER //
// WorkflowInstance.vue?06f78186